// extracted by mini-css-extract-plugin
module.exports = {"filter":"Filtering_filter__3hlrL","filter_body":"Filtering_filter_body__3oiyL"};